import { StyledReleases } from './Releases.style';
import useReleases from './useReleases/useReleases';
import useFilters from './useFilters/useFilters';
import useTableData from './useTableData/useTableData';
import GridChipFilterContainer from 'components/GridChipFilterContainer/GridChipFilterContainer';
import { SEARCH_DATE_FORMAT, TRACKING } from 'common/constants/constants';
import { lightColorPalette } from '@linearb/linui-common';
import QueryString from 'qs';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router';
import useTeamGitFilters from '../../hooks/useTeamGitFilters';
const Releases = ({ withIncidentsCount }) => {
  const location = useLocation();

  const { releases, fetchReleases, isDrilldownMode, setIsDrillDownMode } =
    useReleases({
      withIncidentsCount
    });
  const filters = useFilters();
  const { rows, cols } = useTableData({ releases, withIncidentsCount });
  const history = useHistory();
  useTeamGitFilters();

  const getAdditionalCustomChips = () => {
    if (!isDrilldownMode) {
      return [];
    }

    return [
      {
        label: 'Drill-down view',
        size: 'medium',
        color: 'lb',
        textColor: lightColorPalette.lbGreyDark,
        variant: 'outlined',
        onDelete: () => {
          setIsDrillDownMode(false);
          history.replace({
            pathname: location.pathname,
            search: `?${QueryString.stringify({
              order_by: 'published_at,desc',
              released_at: [
                moment().subtract('7 days').format(SEARCH_DATE_FORMAT),
                moment().format(SEARCH_DATE_FORMAT)
              ].join(',')
            })}`
          });
        }
      }
    ];
  };
  return (
    <StyledReleases>
      <GridChipFilterContainer
        teamsFilterKey='filtered_teams'
        additionalCustomChips={getAdditionalCustomChips()}
        showOnlyAdditionalChips={isDrilldownMode}
        getData={fetchReleases}
        data={releases}
        tableData={() => rows}
        pageTag={TRACKING.PAGES.ACTIVITY}
        pageTabTag={TRACKING.PAGE_TABS.RELEASES}
        filterChipLabelMap={filters.chipLabelMap}
        columns={cols}
        skeletonColumns={filters.loadingSkeleton}
        getReqFilterBody={filters.getReqFilterBody}
        filtersConfig={filters.filtersConfig}
        filtersGroupMap={filters.filtersGroupMap}
        disablePointInHistory
        refreshOnDependencies={filters.refreshOnDependencies}
      />
    </StyledReleases>
  );
};

export default Releases;
